/**
 * 返稿
 * autor:Bai.Zhiming
 * date:2019-4-8
 */
'use strict';
angular.module('iWoRejectionModule', []).controller('iWoRejectionCtrl', ['$scope', '$validation', '$timeout', '$modalInstance', 'selectedArray', 'trsHttpService', 'editingCenterService', function($scope, $validation, $timeout, $modalInstance, selectedArray, trsHttpService, editingCenterService) {
    initStatus();
    initData();

    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            treeOptions: editingCenterService.channelTreeOptions(),
            expanded: [],
            selectedNode: '',
        };
        $scope.data = {
            items: selectedArray,
        };
        $scope.params = {
            serviceid: 'mlf_myrelease',
            methodname: 'receiveRejectionMetaDatas',
            Opinion: '',
            RejectionType: selectedArray.length == 1 ? '1' : '2',
        };
    }

    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        getPeoples();
        getTreeData();
    }

    /**
     * [getPeoples description] 获取经手人
     * @return {[type]} [description]
     */
    function getPeoples() {
        if ($scope.data.items.length != 1) {
            return;
        }
        var params = {
            serviceid: 'mlf_appfgd',
            methodname: 'queryEditFlowGroupPath',
            MetaViewDataId: $scope.data.items[0].METADATAID,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            $scope.data.peoples = data;
            if ($scope.params.RejectionType === '1') {
                $scope.params.UserId = $scope.data.peoples[0].ID;
            } //如果初始化时，返稿类型为返回经手人，则默认选中第一个经手人
        });
    }

    /**
     * [getTreeData description] 获取人员组织树
     * @return {[type]} [description]
     */
    function getTreeData() {
        var params = {
            serviceid: 'mlf_group',
            methodname: 'queryGroupTreeWithMyPath',
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            $scope.data.treeData = [data];
            ExpandedNodes();
            /*$scope.status.selectedNode = data;
            $scope.showSelected($scope.status.selectedNode);
            $scope.status.expanded.push(data);*/
        });
    }

    //默认树展开
    function ExpandedNodes() {
        $scope.status.expanded = [];
        var flag = true;
        $scope.status.expanded.push($scope.data.treeData[0]);
        angular.forEach($scope.data.treeData[0].CHILDREN, function(data, index, array) {
            if (data.ISPATH === 'true') {
                flag = false;
                if (angular.isDefined(data.CHILDREN) && data.CHILDREN.length !== 0) {
                    $scope.status.expanded.push(data);
                    selfPath(data);
                } else {
                    $scope.status.selectedNode = data;
                    getGroupData($scope.status.selectedNode);
                }

            }
        });
        if (flag) {
            $scope.status.selectedNode = $scope.data.treeData[0];
            getGroupData($scope.status.selectedNode);
        }
    }

    function getGroupData(node) {
        $timeout(function() {
                var params = {
                    'serviceid': 'mlf_group',
                    'methodname': 'getUsersByGroup',
                    'GroupId': node.GROUPID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.users = data;
                });
            },
            100);
    }

    function selfPath(data) {
        for (var i = 0; i < data.CHILDREN.length; i++) {
            if (data.CHILDREN[i].ISPATH === 'true') {
                if (data.CHILDREN[i].HASCHILDREN === 'false' || data.CHILDREN[i].CHILDREN.length === 0) {
                    $scope.status.selectedNode = data.CHILDREN[i];
                    getGroupData($scope.status.selectedNode);
                    break;
                } else {
                    $scope.status.expanded.push(data.CHILDREN[i]);
                    selfPath(data.CHILDREN[i]);
                    break;
                }
            }
        }
    }

    /**
     * [showSelected description] 选中节点
     * @param  {[type]} node [description] 被选中节点
     * @return {[type]}      [description]
     */
    $scope.showSelected = function(node) {
        var params = {
            'serviceid': 'mlf_group',
            'methodname': 'getUsersByGroup',
            'GroupId': node.GROUPID,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            $scope.data.users = data;
        });
    };
    /**
     * [showToggle description] 展开节点
     * @param {object} [node] [description] 被点击节点
     * @return {[type]} [description]
     */
    $scope.showToggle = function(node) {
        if (node.HASCHILDREN == 'true' && node.CHILDREN.length === 0) {
            var params = {
                'serviceid': 'mlf_group',
                'methodname': 'queryChildGroupsWithOutRight',
                'GroupId': node.GROUPID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(dataC) {
                node.CHILDREN = dataC.CHILDREN;
            });
        }
    };
    /**
     * [confirm description] 确认
     * @return {[type]} [description]
     */
    $scope.confirm = function() {
        $scope.params.ChnlDocIds = $scope.data.items.map(function(item) {
            return item.CHNLDOCID;
        }).join(',');
        $scope.params.MetaDataIds = $scope.data.items.map(function(item) {
            return item.METADATAID;
        }).join(',');
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(dataC) {
            $modalInstance.close(dataC);
        });
    };
    /**
     * [deleteItem description] 剔除稿件
     * @param {Number} [index] [description] 稿件序号
     * @return {[type]} [description]
     */
    $scope.deleteItem = function(index) {
        if ($scope.data.items.length == 1) {
            return;
        }
        $scope.data.items.splice(index, 1);
        if ($scope.data.items.length == 1) {
            getPeoples();
        }
    };
    /**
     * [selectRejectionWay description] 选择返稿类型
     * @param  {[type]} type [description] 返稿类型
     * @return {[type]}      [description]
     */
    $scope.selectRejectionWay = function(type) {
        $scope.params.RejectionType = type;
        $scope.params.UserId = '';
    };
    /**
     * [selectToRelPeople description] 选择返回经手人
     * @return {[type]} [description]
     */
    $scope.selectToRelPeople = function() {
        $scope.params.RejectionType = '1';
        $scope.params.UserId = $scope.data.peoples[0].ID;
    };
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

}]);
